import { uniqueId } from 'lodash'

const getFileFromBase64 = (data: string, contentType: string, sliceSize: number = 512): File => {
    const byteCharacters = atob(data.replace(`data:${contentType};base64,`, ''))
    const byteArrays: Uint8Array[] = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)

        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
    }

    const blob = new Blob(byteArrays, { type: contentType })
    return new File([blob], uniqueId('asset'), {
        type: blob.type,
        lastModified: Date.now(),
    })
}

export default getFileFromBase64
